<div id="item-container" class="k-h-full k-d-flex k-flex-column">
  <div class="header-area k-d-grid">
    @for (day of weekDays(); track DateTimeHelper.format(day)) {
      <div class="lane">
        <div class="k-m-auto k-py-2 k-text-center">
          <span class="weekday"
            ><span class="k-font-weight-semibold">{{ day | date: "ccc" | uppercase }}</span> |
            {{ day | date: "dd.MM" }}</span
          >
        </div>
      </div>
    }
  </div>
  <div class="content-area k-d-flex k-flex-column k-h-full k-overflow-x-hidden">
    <div
      #fixIntervalLaneContainer
      [ngClass]="[RestrictionAreaCSSClass, TodoEntryFixInterval]"
      [class.empty]="noFixedIntervalTodoEntries()"
      class="wrapper k-d-grid"
    >
      @for (day of weekDays(); track DateTimeHelper.format(day)) {
        <div class="lane {{ CssDropzone }}" [class.is-weekend]="DateTimeHelper.isWeekend(day)">
          <div
            class="k-h-full"
            [ngClass]="TodoEntryFixIntervalWrapper"
            appTodoEntriesWrapper
            [attr.data-date]="DateTimeHelper.format(day)"
            [date]="day"
            #fixIntervalTodoWrapper
          >
            <ng-container appTodoContainer [date]="day" #fixIntervalTodoContainer></ng-container>
          </div>
        </div>
      }
    </div>

    <div [ngClass]="[RestrictionAreaCSSClass, TodoEntryVariableInterval]" class="wrapper k-flex-1">
      @for (day of weekDays(); track DateTimeHelper.format(day); let i = $index) {
        <div
          class="lane {{ CssDropzone }}"
          [class.today]="DateTimeHelper.isToday(day)"
          [class.is-weekend]="DateTimeHelper.isWeekend(day)"
        >
          <div class="k-px-2.5 k-py-3 k-h-full">
            <div
              [ngClass]="TodoEntryVariableIntervalWrapper"
              appTodoEntriesWrapper
              [date]="day"
              [attr.data-date]="DateTimeHelper.format(day)"
              #variableIntervalTodoWrapper
              class="k-pos-relative"
            >
              <ng-container
                appTodoContainer
                [date]="day"
                #variableIntervalTodoContainer
              ></ng-container>
            </div>
            @if (todoPlannerService.activeAddTodoEntryLaneId() === i) {
              <div
                appClickOutside
                [elementVisible]="this.todoPlannerService.activeAddTodoEntryLaneId() >= 0"
                (clickOutside)="addTodo(day, todoValue)"
                (mouseleave)="removeHoverState(addTodoBox)"
              >
                <kendo-textbox
                  #addTodoBox
                  class="textbox k-w-fit k-hover k-mt-1"
                  [(ngModel)]="todoValue"
                  (keydown.enter)="addTodo(day, todoValue)"
                  (blur)="addTodo(day, todoValue)"
                />
              </div>
            }

            @if (todoPlannerService.activeAddTodoEntryLaneId() !== i) {
              <div class="k-w-full" [ngClass]="AddToDoButtonWrapperCSSClass">
                <button
                  kendoButton
                  themeColor="none"
                  class="k-w-full k-border-0"
                  (click)="todoPlannerService.activeAddTodoEntryLaneId.set(i)"
                >
                  <fa-icon
                    class="icon turquoise k-mr-2 k-mt-0.5"
                    size="xs"
                    [icon]="faPlus"
                  ></fa-icon>
                  Aufgabe hinzufügen
                </button>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
